import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import Scroll from 'react-scroll'
import { scroller } from 'react-scroll'

import logo from '../../static/images/portrait.png'

function handleClick(e, scrollTo) {
  e.preventDefault()
  scroller.scrollTo(scrollTo, {
    smooth: true,
  })
}

const setHeight = {
  minHeight: `${ typeof window !== 'undefined' ? window.innerHeight : '' }px`,
}

const setMargin = {
  margin: '15px 0',
}

const IndexPage = () => {
  return (
    <div id="top-of-page" className="container-fluid">
      <div className="row" style={ setHeight }>
        <div className="align-middle text-center" style={{ margin: 'auto' }}>
          <h1>Michael Brooks</h1>
          <img style={{ width: '30%' }} src={ logo } />
          <h2>Web Designer & Developer</h2>
          <p style={{ fontFamily: 'Chunkfive', fontSize: '1.2em' }}>
            <Link onClick={ (e) => handleClick(e, 'portfolio') } to='#portfolio'>Portfolio</Link>
            &nbsp;<span style={{ color: '#F3FFBD' }} >|</span>&nbsp;
            <Link onClick={ (e) => handleClick(e, 'contact') } to='#contact'>Contact</Link>
            &nbsp;<span style={{ color: '#F3FFBD' }} >|</span>&nbsp;
            <Link to='/blog'>Blog</Link>
          </p>
        </div>
        <p>&nbsp;</p>
      </div>
      <div className="row justify-content-center">
        <hr className="col-sm-6" />
      </div>
      <div id="portfolio" style={ setHeight }>
        <p>&nbsp;</p>
        <h2 className="text-center">Portfolio</h2>
        <div className="row">
          <div className="col-sm" style={ setMargin }>
            <div className="card">
              <img className="card-img-top" src="/images/placeholder.png" />
              <div className="card-body">
                <h4 className="card-title">Card title</h4>
                <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                <a href="#" className="btn btn-primary btn-block">Go somewhere</a>
              </div>           
            </div>
          </div>
          <div className="col-sm" style={ setMargin }>
            <div className="card">
              <img className="card-img-top" src="/images/placeholder.png" />
              <div className="card-body">
                <h4 className="card-title">Card title</h4>
                <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                <a href="#" className="btn btn-primary btn-block">Go somewhere</a>
              </div>
            </div>
          </div>
          <div className="col-sm" style={ setMargin }>
            <div className="card">
              <img className="card-img-top" src="/images/placeholder.png" />
              <div className="card-body">
                <h4 className="card-title">Card title</h4>
                <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                <a href="#" className="btn btn-primary btn-block">Go somewhere</a>
              </div>           
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm" style={ setMargin }>
            <div className="card">
              <img className="card-img-top" src="/images/placeholder.png" />
              <div className="card-body">
                <h4 className="card-title">Card title</h4>
                <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                <a href="#" className="btn btn-primary btn-block">Go somewhere</a>
              </div>           
            </div>
          </div>
          <div className="col-sm" style={ setMargin }>
            <div className="card">
              <img className="card-img-top" src="/images/placeholder.png" />
              <div className="card-body">
                <h4 className="card-title">Card title</h4>
                <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                <a href="#" className="btn btn-primary btn-block">Go somewhere</a>
              </div>
            </div>
          </div>
          <div className="col-sm" style={ setMargin }>
            <div className="card">
              <img className="card-img-top" src="/images/placeholder.png" />
              <div className="card-body">
                <h4 className="card-title">Card title</h4>
                <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                <a href="#" className="btn btn-primary btn-block">Go somewhere</a>
              </div>           
            </div>
          </div>
        </div>
        <p>&nbsp;</p>
      </div>
      <div className="row justify-content-center">
        <hr className="col-sm-6" />
      </div>
      <div id="contact" style={ setHeight }>
        <p>&nbsp;</p>
        <h2 className="text-center">Find out what I can do for you</h2>
        <div className="jumbotron col-sm-12 col-md-8" style={{ background: '#fff', margin: 'auto' }}>
          <form action="" data-netlify="true">
            <div className="form-row">
              <div className="form-group col-sm-6">
                <label for="name">Name*</label>
                <input required type="text" className="form-control" id="name" placeholder="Joe Blogs" />
              </div>
              <div className="form-group col-sm-6">
                <label for="email">Email*</label>
                <input required type="email" className="form-control" id="email" placeholder="email@example.com" />
              </div>
            </div>
            <div className="form-group">
              <label for="message">Message*</label>
              <textarea required className="form-control" id="message" rows="3" placeholder="Message text"></textarea>
            </div>
            <button type="submit" className="btn btn-success btn-block">Send Email</button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js